import { ChevronDown } from 'react-feather'

type Props = {
  showLessons: boolean
  setShowLessons: (value: React.SetStateAction<boolean>) => void
}

const ShowAllLessonsButton = ({ showLessons, setShowLessons }: Props) => (
  <button
    onClick={() => setShowLessons((prevState) => !prevState)}
    className="flex items-center focus:outline-none text-orange font-600 hover:underline"
  >
    <span>{showLessons ? 'Hide' : 'View'} all lessons </span>
    <ChevronDown
      className={`w-5 transform duration-300 transition-all ${
        showLessons ? 'rotate-180' : ''
      }`}
    />
  </button>
)

export default ShowAllLessonsButton
